export default {
  /**
   * Nombre del componente
   */
  name: 'YuriIcon',

  /**
   * @override
   */
  props: {
    icon: {
      type: String,
      required: false
    },
    fontSize: {
      type: Number,
      required: false,
      default: 21
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    }
  }
};
